{
  "SEARCH": {
    "TABS": {
      "ALL": "Tất cả",
      "CONTACTS": "Danh bạ",
      "CONVERSATIONS": "Các cuộc hội thoại",
      "MESSAGES": "Tin nhắn"
    },
    "SECTION": {
      "CONTACTS": "Danh bạ",
      "CONVERSATIONS": "Các cuộc hội thoại",
      "MESSAGES": "Tin nhắn"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "Đang tìm kiếm",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "No {item} found for query '{query}'",
    "EMPTY_STATE_FULL": "No results found for query '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ to focus",
    "INPUT_PLACEHOLDER": "Type 3 or more characters to search",
    "RECENT_MESSAGES": "Tin nhắn tôi vừa gửi gần đây",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Read more",
    "WROTE": "wrote:",
    "FROM": "từ",
    "EMAIL": "email",
    "EMAIL_SUBJECT": "chủ đề"
  }
}
